import i18next from 'i18next';
import i18nextXHRBackend from 'i18next-xhr-backend';

export enum TranslationNamespace {
  translation = 'translation',
  site = 'site',
}

export default function i18n(locale: string, siteLanguage: string, baseUrl: string = '') {
  return i18next
    .createInstance()
    .use(i18nextXHRBackend)
    .init({
      ns: [TranslationNamespace.translation, TranslationNamespace.site],
      defaultNS: TranslationNamespace.translation,
      fallbackNS: TranslationNamespace.translation,
      lng: locale,
      fallbackLng: 'en',
      keySeparator: '$',
      interpolation: {
        escapeValue: false,
      },
      react: {
        wait: true,
      },
      backend: {
        loadPath: (languages: string[], namespaces: string[]) => {
          if (namespaces[0] === TranslationNamespace.translation) {
            return `${baseUrl}assets/locale/messages_{{lng}}.json`;
          } else {
            return `${baseUrl}assets/locale/messages_${siteLanguage}.json`;
          }
        },
        crossDomain: true,
      },
    });
}
